import { useNavigate } from "react-router-dom";
import { Routes } from "router/routes";
import { hireBackgroundImage } from "assets/website";
import type { EventData } from "../data";
import { getLumaEventId, useLumaCheckoutScript } from "../lumaCheckout";

interface CtaProps {
  event: EventData;
}

const Cta: React.FC<CtaProps> = ({ event }) => {
  const navigate = useNavigate();
  useLumaCheckoutScript();
  const lumaEventId = getLumaEventId(event.lumaUrl);

  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-[1024px] mx-auto lg:px-8 px-6">
        <div className="relative rounded-3xl overflow-hidden">
          <div
            className="absolute inset-0"
            style={{
              backgroundImage: `url(${hireBackgroundImage})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          />
          <div className="absolute inset-0 bg-black/70" />

          <div className="relative z-10 px-6 md:px-8 lg:px-20 py-12 md:py-16 text-center">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-display font-[550] text-white mb-4 lg:mx-16">
              {event.finalCta.title}
            </h2>
            <p className="text-neutral-300 text-lg lg:text-xl max-w-2xl mx-auto mb-10">
              {event.finalCta.body}
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <a
                href={event.lumaUrl}
                target="_blank"
                rel="noopener noreferrer"
                data-luma-action="checkout"
                data-luma-event-id={lumaEventId}
                className="px-8 py-4 bg-transparent hover:bg-transparent text-[#FFFFFF] border-[2px] border-[#FFFFF] text-base font-semibold rounded-lg transition-all duration-200 w-full sm:w-auto text-center"
              >
                Reserve my Seat
              </a>
              <button
                onClick={() => navigate(Routes.signup)}
                className="px-8 py-4 bg-[#012169] hover:bg-[#01154d] text-white text-base font-semibold rounded-lg transition-all duration-200 hover:shadow-lg w-full sm:w-auto"
              >
                Assess Talents with Precision
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export { Cta };
